export function boot() {
  // var d = new Date();
  // console.log(d);

  // phase 2
  //change html to be: Today is Election Day. Be in line by 8 p.m to vote in person
  //remove all the innerHTML and display-block from dayOF,
  //change css to automatically have that showing.

  var countdown = document.querySelector('.countdown');
  var timer = document.querySelector('.timer');
  var dayDiv = document.querySelector('.days');
  var hourDiv = document.querySelector('.hours');
  var minDiv = document.querySelector('.minutes');
  var secDiv = document.querySelector('.seconds');
  let labelOne = document.querySelector('.label-one');
  let labelTwo = document.querySelector('.label-two');
  let votingLine = document.querySelector('.voting-instructions');
  let aLink = document.querySelector('.embed-related');
  let relatedImg = document.querySelector('.related-img');

  // Set the date we're counting down to
  //var countDownDate = new Date('Oct 30, 2020 11:33:30').getTime();
  var electionDay = new Date('Nov 3, 2020 20:00:00').getTime();
  var runThrough = false;

  //grab the time stamp as soon as somebody gets on the page
  var currently = new Date().getTime();

  function dayOf() {
    countdown.classList.add('day-of');
    dayDiv.innerHTML = '-';
    hourDiv.innerHTML = '-';
    minDiv.innerHTML = '-';
    secDiv.innerHTML = '-';
    labelOne.innerHTML = 'Today is ';
    labelTwo.innerHTML = 'Election Day.';
    votingLine.innerHTML = 'Be in line by 8 p.m. to vote in person';
    votingLine.style.display = 'block';
  }

  function watchResults() {
    votingLine.style.display = 'none';
    timer.style.display = 'none';
    labelOne.innerHTML =
      '<a href="https://www.latimes.com/projects/2020-presidential-election-live-results/"><span class="live"></span> <span class="underline">Live election results</span></a>';
    labelTwo.innerHTML = '';
    dayDiv.innerHTML = '-';
    hourDiv.innerHTML = '-';
    minDiv.innerHTML = '-';
    secDiv.innerHTML = '-';
    if (aLink) {
      aLink.style.display = 'none';
    }
    relatedImg.style.display = 'block';
  }

  //if countdowndate is still upcoming
  if (currently < electionDay) {
    //start it once with the original countdown date
    startClock(electionDay);
    //countdown.classList.add('day-of');

    // dayOf();
  }

  //if election day has also passed then we just want to put the refer to the election results page
  else if (electionDay < currently) {
    //just skip to the watch results styling
    watchResults();
  }

  //run this function once and set runThrough to true at the end. then call itself at the end if it's false with a new time.

  function startClock(endTime) {
    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = endTime - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      //make the divs display different times
      dayDiv.innerHTML = days;
      hourDiv.innerHTML = hours;
      minDiv.innerHTML = minutes;
      secDiv.innerHTML = seconds;

      // If the count down is finished, write some text
      if (distance <= 0) {
        clearInterval(x);
        watchResults();
        //if we haven't been through this timer before, call the election day timer
        //console.log(runThrough);
      }
    }, 1000);
  }
}
